<template>
    <div v-loading="loading">
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%; margin-bottom: 10px" min-height="530px">
                <el-table-column fixed show-overflow-tooltip label="操作类型" prop="OpTypeName"> </el-table-column>
                <el-table-column min-width="200" label="操作说明">
                    <template slot-scope="scope">
                        <el-tooltip placement="top" popper-class="uol-tooltip-content">
                            <div slot="content" v-html="$options.filters.textSplit(scope.row.Remark)"></div>
                            <div class="tooltip-div">{{ scope.row.Remark }}</div>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="160" prop="CreateTime" label="操作时间"></el-table-column>
                <el-table-column show-overflow-tooltip width="80" prop="Oper" label="操作人"></el-table-column>
            </el-table>
            <el-pagination
                v-if="tableDataLength != 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['OrderId','OrderType'],
    components: {},
    data() {
        return {
            loading: false,
            searchData: {
                OrderType:'',
                OrderId: '',
                page: 1,
                limit: 10
            },
            tableData: [],
            tableDataLength: 0
        };
    },
    filters: {
        textSplit(x) {
            if (~x.indexOf('；')) {
                return x.split('；').join('<br/>');
            } else {
                return x;
            }
        }
    },
    mounted() {
        this.searchData.OrderId = this.OrderId;
        this.searchData.OrderType = this.OrderType;
        this.getTableData();
    },
    methods: {
        getTableData() {
            let that = this;
            that.loading = true;

            that.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpOrderOpLogList',
                    data: this.searchData
                })
                .then(res => {
                    that.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    that.tableData = data;
                    that.tableDataLength = res.count;
                })
                .catch(() => {
                    that.loading = false;
                });
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>

<style lang="less">
.uol-tooltip-content {
    text-align: right;
}
</style>
<style lang="less" scoped>
.tooltip-div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
}
</style>
